export interface IToolItem {
  href: string;
  label: string;
}

export const TOOL_ITEMS: IToolItem[] = [
  { href: "https://zhuba-ahhh.github.io/gradient-editor", label: "渐变编辑器" },
  { href: "https://zhuba-ahhh.github.io/RichTextEditor", label: "富文本编辑器" },
  { href: "https://zhuba-ahhh.github.io/MicroCode", label: "低代码编辑器" },
  { href: "https://svg-editor-blond.vercel.app", label: "SVG 编辑器" },
  { href: "https://zhuba-ahhh.github.io/JsonTool", label: "JSON 工具" },
];
